import React from "react";
import { Heading } from "components/Heading";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import intl from "react-intl-universal";

import { IPlayerListProps } from "./types";
import { EditPlayer } from "./EditPlayer";

export const PlayerList = ({
  teamId,
  players,
  viewerRoles,
  onAdd,
  onRemove,
  onUpdate,
}: IPlayerListProps) => {
  const handleAddClick = () => {
    onAdd();
  };

  return (
    <>
      <Heading
        title={intl.get("TEAM_EDIT_PLAYERS")}
        rightAction={
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            {intl.get("TEAM_EDIT_ADD_PLAYER")}
          </Button>
        }
      />
      {players.map((player) => (
        <EditPlayer
          teamId={teamId}
          player={player}
          key={player.id}
          viewerRoles={viewerRoles}
          onRemove={onRemove}
          onUpdate={onUpdate}
        />
      ))}
    </>
  );
};
